<template>
  <div class="Wapper" :class="{ border }">
    <div class="warpper-title">
      {{ title }}<span v-show="more" @click="seeMore">更多></span>
    </div>
    <div :style="{ padding: `${padding}px` }">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    border: {
      type: Boolean,
      default: true,
    },
    more: {
      type: Boolean,
      default: true,
    },
    title: {
      type: String,
      default: "",
    },
    padding: {
      type: Number,
      default: 8,
    },
  },
  methods: {
    seeMore() {
      this.$emit("more");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/styles/variables.scss"; // global css

.Wapper {
  height: 100%;
  &.border {
    border: 1px solid rgba($color: $main-color, $alpha: 0.6);
    .warpper-title {
      border: none;
      border-bottom: 1px solid rgba($color: $main-color, $alpha: 0.6);
    }
  }
  .warpper-title {
    line-height: 30px;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    color: $main-color;
    font-size: 14px;
    font-weight: bold;
    background: linear-gradient(
      to bottom,
      #fff,
      rgba($color: $main-color, $alpha: 0.3)
    );
    border: 1px solid rgba($color: $main-color, $alpha: 0.6);
    span {
      color: #555;
      font-weight: 400;
      font-size: 12px;
      cursor: pointer;
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
</style>
